import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import { Tab } from 'lib/types/shared';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import AllInvoices from './components/AllInvoices';
import LastInvoices from './components/LastInvoices';

const tabs: Tab[] = [
  {
    index: 1,
    label: 'Transables',
    component: <LastInvoices />,
    path: 'financiable',
  },
  {
    index: 2,
    label: 'Todas',
    component: <AllInvoices />,
    path: 'all',
  },
];

const MyInvoices = () => {
  const { page } = useParams<{
    id: string;
    businessId: string;
    page: string;
  }>();
  const [loading, setLoading] = useState(true);
  const [companyTabs, setCompanyTabs] = useState<Tab[]>([]);

  const [startValue, setStartValue] = useState(0);

  const setUpTabs = () => {
    const newProfileTabs = [...tabs];
    let startValueDefault = 0;
    startValueDefault = newProfileTabs.findIndex((x) => x.path === page);
    setCompanyTabs(newProfileTabs);
    setStartValue(startValueDefault === -1 ? 0 : startValueDefault);
    setLoading(false);
  };

  useEffect(() => {
    setUpTabs();
  }, []);
  if (loading) return <CenteredCircularProgress />;

  return (
    <div>
      <EnhancedTab
        tabType="secondary"
        startValue={startValue}
        tabs={companyTabs}
        // canShowTab={checkCanAccessView()}
      />
    </div>
  );
};

export default MyInvoices;
